import React, { useState, useEffect } from 'react';
import { Carousel, Image } from 'antd';
import axios from 'axios';
import { get } from 'lodash';

const contentStyle: React.CSSProperties = {
  height: '300px',
  color: '#fff',
  lineHeight: '160px',
  textAlign: 'center',
  background: '#364d79',
};

const Slide: React.FC = (props) => {
  const [slide, setSlide] = useState([]);
  const loadSlide = async () => {
    const { data } = await axios.get(`/banner?type=technician`);
    setSlide(data.data);
  };

  useEffect(() => {
    loadSlide();
  }, []);

  return (
    <>
      {slide.length > 0 ? (
        <Carousel
          autoplay
          autoplaySpeed={get(
            slide,
            `${slide.length - 1}.autoPlaySpeed`,
            2000
          )}
        >
          {slide.map((item: any) => {
            return (
              <>
                <div>
                  <h3 style={contentStyle}>
                    <a href={item.link}>
                      <Image src={item.url} preview={false} />
                    </a>
                  </h3>
                </div>
              </>
            );
          })}
        </Carousel>
      ) : (
        <></>
      )}
    </>
  );
};

export default Slide;
